import { render, staticRenderFns } from "./SummaryDeposit.vue?vue&type=template&id=2c42c604&"
import script from "./SummaryDeposit.vue?vue&type=script&lang=js&"
export * from "./SummaryDeposit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports